import api from "./api";

const KEY = "apto_visit_queue";

export const getQueue = () => JSON.parse(localStorage.getItem(KEY) || "[]");
const setQueue = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export function enqueueVisit(payload) {
  const q = getQueue();
  q.push({ ...payload, _localId: payload.id, _queuedAt: Date.now() });
  setQueue(q);
}

export function removeFromQueue(localId) {
  setQueue(getQueue().filter((v) => v._localId !== localId));
}

export async function saveVisit(payload) {
  if (!navigator.onLine) {
    enqueueVisit(payload);
    return { offline: true };
  }
  try {
    const { data } = await api.post("/visits", payload);
    return { offline: false, data };
  } catch (e) {
    enqueueVisit(payload);
    return { offline: true };
  }
}

export async function syncQueue() {
  const q = getQueue();
  let synced = 0;
  for (const item of q) {
    try {
      const { _localId, _queuedAt, ...payload } = item;
      await api.post("/visits", payload);
      removeFromQueue(item._localId);
      synced++;
    } catch (e) {
      break;
    }
  }
  return synced;
}
